document.addEventListener('turbolinks:load', () => {
  Array.from(document.querySelectorAll('.folding-block-header')).forEach(header => {
    const body = header.nextElementSibling
    header.addEventListener('click', (event) => {
      body.style.maxHeight = body.style.maxHeight ? null : `${body.scrollHeight}px`
    })
  })

})
